const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGOUT: 'LOGOUT',

  SIGNUP_REQUEST: 'SIGNUP_REQUEST',
  SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
  SIGNUP_ERROR: 'SIGNUP_ERROR',

  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',

  SETTINGS_UPDATE: 'SETTINGS_UPDATE',
  SETTINGS_UPDATE_SUCCESS: 'SETTINGS_UPDATE_SUCCESS',

  /*
  authentication actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\auth\saga.js
  */

  login: userInfo => ({
    type: actions.LOGIN_REQUEST,
    userInfo,
  }),

  forgotPassword: userInfo => ({
    type: actions.FORGOT_PASSWORD,
    userInfo,
  }),

  logout: () => ({
    type: actions.LOGOUT,
  }),

  signup: userInfo => ({
    type: actions.SIGNUP_REQUEST,
    userInfo,
  }),

  // to update the current user settings
  apiSettingsUpdate: updatedUser => ({
    type: actions.SETTINGS_UPDATE,
    updatedUser,
  }),

  // test check authorization function
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
};
export default actions;
